import SpinwheelPhoneVerification from '../../../../onboarding/components/spinwheel/SpinwheelPhoneVerification';

export default function SpinwheelPhoneVerificationScreen() {
    return <SpinwheelPhoneVerification />;
}
